import { GvInputController } from "../../../../components/Controllers";
import React from "react";
import { SignInEmailSchema } from "../../../../services/user/user.schema";

import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import MobileForm from "./MobileForm";

type Props = {
  loginMethod: string;
  handleSendOTP: (data: any) => void;
}

const LoginForm = (props: Props) => {
  const { loginMethod, handleSendOTP } = props;

  const { control: emailControl, handleSubmit: handleSubmitEmail } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(SignInEmailSchema),
    defaultValues: {
      email: "",
    },
  });

  return (
    <>
      {loginMethod === "email"?
        <>
          <form onSubmit={handleSubmitEmail(handleSendOTP)}>

            <GvInputController
              control={emailControl}
              name="email"
              label="Email"
              placeholder="Email Address"
              className="font-semibold"/>
            <Button
              id="sendOtpButton"
              color="primary"
              type="submit"
              className="!capitalize !font-bold"
              fullWidth
              sx={{ mt: "2rem" }}>Send Verification Code</Button>
          </form>
        </> :
        <MobileForm
          handleSendOTP={handleSendOTP}
        />
      }
    </>
  );
};

export default LoginForm;
